import React from "react";
import { RxCross2 } from "react-icons/rx";
import "./style.css";

const ModalV2 = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  children,
  cancelButtonLabel = "Cancel",
  confirmButtonLabel = "Save",
  confirmDisabled = false,
  size = "medium", // can be "small", "medium", or "large"
  hideFooter = false,
  closeOnOverlayClick = true,
  cancelOnLeft = false,
  onCancel,
}) => {
  const handleOverlayClick = (e) => {
    if (!closeOnOverlayClick) return;
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-v2-overlay" onClick={handleOverlayClick}>
      <div className={`modal-v2 modal-v2-${size}`}>
        <div className="modal-v2-header">
          <h2>{title || "Add How-to Video"}</h2>
          <button type="button" className="modal-v2-close" onClick={onClose}>
            {/* × */}
            <RxCross2 />
          </button>
        </div>

        <div className="modal-v2-content">{children}</div>

        {!hideFooter && (
          <div
            className={`modal-v2-footer ${cancelOnLeft ? "modal-v2-footer-split" : ""}`}
          >
            <button
              type="button"
              className="modal-v2-btn modal-v2-btn-cancel"
              onClick={onCancel ?? onClose}
            >
              {cancelButtonLabel}
            </button>
            <button
              type="button"
              className="modal-v2-btn modal-v2-btn-confirm"
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              {confirmButtonLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalV2;
